import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    courseInfo: ''
  },
  getters:{
    getCourseInfo:function (state) {
      return state.courseInfo;
    }
  },
  mutations: {
    SET_COURSEINFO:(state, CourseInfo) =>{
      state.courseInfo = CourseInfo;
    }
  },
  actions: {
    setCourseInfoFunction(context, CourseInfo){
      context.commit('SET_COURSEINFO', CourseInfo);
    }
  },
  modules: {
  }
})
